<template>
  <div class="ui-tooltips  ui-tooltips-top-left-arrow  [ ui-tooltips-warning ]" :class="{'hide': !visible}">
    <div class="ui-tooltips-arrow">
        <span class="arrow  arrow-out">&#9670;</span>
        <span class="arrow">&#9670;</span>
    </div>
    <div class="ui-tooltips-content">
        <!--
        @notice 下面 DOM 二选一
        -->

        <!--
        含有图标
        -->
        <p class="ui-tooltips-msg">
            <span class="vipFont  if-sigh">&#xe620;</span>{{text}}
        </p>

        <!--
        纯文案
        -->
        <p>{{text}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    text: {
      type: [String, Number]
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.ui-tooltips {
  position: relative;
  display: inline-block;
  width: auto;
  line-height: 18px;
  font-size: 12px;
  transition-duration: .25s;
  transition: transform ease-out .15s,opacity ease-out .15s;
  .ui-tooltips-arrow {
    position: absolute;
    z-index: 1;
    transform: translate(0, 0);
    border: 1px solid #dbdada;
    border-radius: 2px;
    box-shadow: 0 0 3px rgba(0,0,0,.1);
    .arrow {
      position: absolute;
      font-size: 12px;
      top: -8px;
      left: 15px;
      color:#fff;
      // border-width: 10px;
      // border-style: solid;
      &.arrow-out {
        top: -9px;
        color: #dbdada;
        text-shadow: 0 0 4px rgba(0,0,0,.15);
      }
    }
  }
  .ui-tooltips-content {
    position: relative;
    background-color: #fff;
    padding: 6px 15px;
    border: 1px solid #dbdada;
    border-radius: 2px;
    box-shadow: 0 0 3px rgba(0,0,0,.1);
    color: #4d4d4d;
    .ui-tooltips-msg {
      display: none;
    }
  }
}
</style>
